import {
  Pedido,
  ShipmentItem,
  ShipmentPedido,
} from "services/realizarCotacao/realizarCotacao.types";

export const convertPedidoToShipmentPedido = (
  pedido: Pedido,
): ShipmentPedido => {
  const itens: ShipmentItem[] = pedido.itens.map((item) => {
    const peso = Number(item.pesoUnit) || 0;

    return {
      sku: item.sku,
      nome: item.titulo,
      quantidade: item.qty,
      preco_unitario: item.preco,
      peso_kg: peso,
    };
  });

  const peso_total_kg = itens.reduce((acc, item) => {
    const peso = item.peso_kg ?? 0;
    const quantidade = item.quantidade ?? 0;
    return acc + peso * quantidade;
  }, 0);

  return {
    id: pedido.id,
    cliente_id: pedido.cliente_id,
    pedido_ref: pedido.pedido_ref,
    moeda: pedido.moeda,
    total: pedido.total,
    nomeComprador: pedido.nomeComprador,
    emailComprador: pedido.emailComprador,
    telefoneComprador: pedido.telefoneComprador,
    endereco: pedido.endereco,
    cidade: pedido.cidade,
    estado: pedido.estado,
    CEP: pedido.CEP ?? undefined,
    pais: pedido.pais,
    itens,
    peso_total_kg,
  };
};
